export default {"src":"/_next/static/media/left_filled.2e291622.svg","height":24,"width":24};